import Ad from "@components/Advertisement/Ad";
import CandidatesLineUpBanner from "@pages/SingaporeGe/2025/components/CandidatesLineUpBanner";
import Highlights from "@pages/SingaporeGe/2025/components/Highlights";
import IframeEmbed from "@pages/SingaporeGe/2025/components/IframeEmbed";
import RelatedStoriesOverview from "@pages/SingaporeGe/2025/components/RelatedStoriesOverview";
import Videos from "@pages/SingaporeGe/2025/components/Videos";
import Whatsapp from "@pages/SingaporeGe/2025/components/Whatsapp";
import { SingaporeGEBasicProps } from "@pages/SingaporeGe/2025/utils/types";
import { ConfigTypeEnums } from "@typings/enums";
import { cn } from "@util/helpers";

/**
 * SingaporeGeComponentFactory component to render different components based on the configuration type.
 */
const SingaporeGeComponentFactory = ({
  configData,
  highlights,
  relatedStories,
  index,
  parentIndex,
  entity,
}: SingaporeGEBasicProps): React.ReactElement => {
  if (typeof configData === "string" || !configData) return <></>;

  switch (configData.type) {
    case ConfigTypeEnums.TOPSTORIES:
      if (!highlights) return <></>;

      return (
        <Highlights
          cardProps={highlights}
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": parentIndex !== 0 || index !== 0,
            },
            configData?.extraClass
          )}
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.RELATEDSTORIES:
      if (!relatedStories) return <></>;

      return (
        <RelatedStoriesOverview
          cardProps={relatedStories}
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": parentIndex !== 0 || index !== 0,
            },
            configData?.extraClass
          )}
          gaObject={configData.gaObject}
          entity={entity}
        />
      );

    case ConfigTypeEnums.IFRAME:
      if (!configData) return <></>;

      return (
        <IframeEmbed
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": index !== 0,
            },
            configData?.extraClass
          )}
          key={`iframe-${index}`}
          configData={configData}
          index={index || 0}
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.ADS:
      if (!configData.adType) return <></>;

      return (
        <Ad
          adType={configData.adType}
          className="flex items-center justify-center lg:sticky lg:top-20"
        />
      );

    case ConfigTypeEnums.VIDEOS:
      return (
        <Videos
          testId="ge-2025-videos-component"
          className={cn(
            "mb-8 border-t border-gray-850 pt-3",
            configData?.extraClass
          )}
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.WHATSAPP:
      return (
        <Whatsapp
          className={cn(
            "border border-gray-850 p-2 lg:mb-6",
            configData?.extraClass
          )}
          testId="ge-2025-whatsapp-component"
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.BANNER:
      return <CandidatesLineUpBanner configData={configData} />;

    case ConfigTypeEnums.CREDITS:
      return (
        <div className={cn("mb-8", configData?.extraClass)}>
          <p className="font-poppins text-xs font-light text-gray-850">
            {configData.title}
          </p>
        </div>
      );

    default:
      return <></>;
  }
};

export default SingaporeGeComponentFactory;
